import { COLOR_KEYS } from 'frontend/constants';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectColors } from '../selectors/applicationSelectors';

export const useColors = () => {
  const colors = useSelector(selectColors);

  return useMemo(() => ({
    background: colors?.background || COLOR_KEYS.DEFAULT_BACKGROUND,
    defaultBackground: COLOR_KEYS.DEFAULT_BACKGROUND,
    text: colors?.text || COLOR_KEYS.DEFAULT_TEXT,
    gray: colors?.gray || COLOR_KEYS.DEFAULT_COLOR_GRAY,
    coral: COLOR_KEYS.CORAL,
  }), [colors]);
};
